export default __webpack_public_path__ + "static/media/icon-application-comparison.3e7cdc08.svg";